import { action as apiAction } from 'api/Api'
import {
  remove
} from '../redux/dates'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  dateId: number
}

const requestRemoveCustomDate = (payload: Payload) => async dispatch => {
  const { cardId, dateId } = payload

  const optimisticAction = optimisticDispatch(dispatch, remove({
    cardId,
    dateId: dateId
  }))

  try {
    await apiAction('RemoveCustomDate', {
      id: dateId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRemoveCustomDate
